export class DataModification {
    moduleName: string;
    engagementId: number;
    createdBy: string;
    createdByName: string;
    editStatus: boolean=false;
    editingMembers: string[];
}